jQuery($ => {
	const $w = $(window);
	const header = document.getElementById('header');
	if (header) {
		$w.on('load', () => {
			$w.scroll(() => {
				if (window.pageYOffset > 0) {
					header.classList.add('sticky');
				} else {
					header.classList.remove('sticky');
				}
			});
			$w.trigger('scroll');
		});
	}
});
